module.exports = __webpack_public_path__ + "img/j-logo.9fac145f.png";